import { Pinia, Store } from 'pinia-class-component';
import { ActionDefinition, ActionsApiUiClient } from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
  id: 'ActionDefinitionStore',
  name: 'ActionDefinitionStore',
})
export default class ActionDefinitionStore extends Pinia {
  private readonly api = initClient(ActionsApiUiClient);

  //data
  private _loadingPromise: Promise<ActionDefinition[]> | null = null;
  private _definitions: ActionDefinition[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get definitions(): ActionDefinition[] {
    return this._definitions;
  }

  get definitionsById(): Map<string, ActionDefinition> {
    return new Map(this._definitions.map(e => [e.id, e]));
  }

  //actions
  clear(): void {
    this._definitions.splice(0);
  }

  setDefinitions(cells: ActionDefinition[]): void {
    this._definitions.splice(0);
    this._definitions.push(...cells);
  }

  addDefinition(definition: ActionDefinition): void {
    this._definitions.push(definition);
  }

  updateDefinition(definition: ActionDefinition): void {
    const index = this._definitions.findIndex(e => e.id === definition.id);
    if (index >= 0) {
      this._definitions.splice(index, 1, definition);
    } else {
      this._definitions.push(definition);
    }
  }

  forgetDefinition(definition: ActionDefinition): void {
    const index = this._definitions.findIndex(e => e.id === definition.id);
    if (index >= 0) {
      this._definitions.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.api.list();
      const cells = await this._loadingPromise;
      this.setDefinitions(cells);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._definitions.length > 0) {
      return;
    }
    return await this.reload();
  }
}